export default __webpack_public_path__ + "media/images/mailer/icon_file_download-e9546bde2c736e33c1e7b0f564dfe714.png";